import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CommunicationMessage,
  IllustrationSize,
  Illustrations,
} from '../Communication/CommunicationMessage';
import './ListEmptyPlaceholder.scss';

interface ListEmptyPlaceholder {
  headline?: string;
  size?: IllustrationSize;
  text?: string;
}

export const ListEmptyPlaceholder: React.FC<ListEmptyPlaceholder> = ({
  headline,
  size,
  text,
}) => {
  const { t } = useTranslation();
  return (
    <div className="listEmptyPlaceholder">
      <CommunicationMessage
        illustration={Illustrations.Empty}
        headline={headline ?? t('list_empty', { defaultValue: 'Keine Einträge vorhanden' })}
        illustrationSize={size ?? IllustrationSize.Small}
        text={text ?? ''}
      />
    </div>
  );
};
